import React from "react";
import { RootState } from "@store/index";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useIsTablet } from "@hooks/use-is-tablet";
import { isLiteTmsSupplierRole } from "@helpers/permission";

export function RootRedirect() {
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const isTablet = useIsTablet();

  if (!role) return null;

  if (role === "WMS+Operations") {
    return <Navigate to="/wms" replace />;
  }

  if (isLiteTmsSupplierRole(role)) {
    return <Navigate to="/tms" replace />;
  }

  if (role === "Operations" || role === "Customer") {
    return <Navigate to="/shippings" replace />;
  }

  if (isTablet) {
    return <Navigate to="/wms" replace />;
  }

  return <Navigate to="/offers" replace />;
}
